import moment from 'moment';

export default {
    methods: {
        formatTimeDiff(date, format = 'MMM-DD-YY') {
            const newDate = new Date(date);
            if(newDate) {
                const currentDate = moment();
                const targetDate = moment(newDate, format);

                const years = currentDate.diff(targetDate, 'years');
                targetDate.add(years, 'years');

                const months = currentDate.diff(targetDate, 'months');
                targetDate.add(months, 'months');

                const days = currentDate.diff(targetDate, 'days');

                // return `${years}yr - ${months}mo - ${days}d`;
              return `${days}d - <span style="color: #93c47d;">${months}mo</span> - <span style="color: #428bca;">${years}yr</span>`;

            }
            return ""
        },
        formatDate(date) {
            if (!date) {
                return "";
            }

            const parsedDate = new Date(date);
            if (isNaN(parsedDate)) {
                return "";
            }

            return parsedDate.toLocaleDateString("en-US", {
                timeZone: "America/Los_Angeles",
                month: "short",
                day: "numeric",
                year: "numeric"
            });
        }
    }
}
